import * as React from "react";
import { useEffect, useState } from "react";

import {DataGrid,GridToolbar} from "@mui/x-data-grid";

import { customerService } from "../../services/customer.service";
import {
  GetCustomerTransListAtom,
  SetCustomerTransListAtom,
  ResetCustomerTransListAtom,
} from "../../store/customerTransListAtom";
import CustomerHistorySelect from "./CustomerHistorySelect";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import DelgroProgressBar from "../../generals/DelgroProgressBar";

const columns = [
  {
    title: "Ref No",
    dataIndex: "Ref_No",
    sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')
  },  
  {
    title: "Transaction Date",
    dataIndex: "Transaction_Date",
    sorter: (a, b) => (a?.Transaction_Date ?? '').localeCompare(b?.Transaction_Date ?? ''),
    render: (record) => <span> {formatCustomDate(record)} </span>,
    
  },
  {
    title: "Transaction Type",
    dataIndex: "Transaction_Type_Name",
    sorter: (a, b) => (a?.Transaction_Type_Name ?? '').localeCompare(b?.Transaction_Type_Name ?? '')
  },
  {
    title: "Narration",
    dataIndex: "Narration",
    sorter: (a, b) => (a?.Narration ?? '').localeCompare(b?.Narration ?? '')
  },
  {
    title: "Previous Balance",
    dataIndex: "Previous_Wallet_Balance",
    sorter: (a, b) => (a?.Previous_Wallet_Balance ?? '') - (b?.Previous_Wallet_Balance ?? ''),
    render: (amount) =>  <span>{formatCustomNumber(amount)} </span>
  },
  {
    title: "Transaction Amount",
    dataIndex: "Amount",
    sorter: (a, b) => (a?.Amount ?? '') - (b?.Amount ?? ''),
    render: (amount) =>  <span>{formatCustomNumber(amount)} </span>
  },
  {
    title: "Current Wallet Balance",
    dataIndex: "Current_Wallet_Balance",
    sorter: (a, b) => (a?.Current_Wallet_Balance ?? '') - (b?.Current_Wallet_Balance ?? ''),
    render: (amount) =>  <span>{formatCustomNumber(amount)} </span>
  },
];

export default function CustomerTransactionTab({ customer_id }) {
  const [tableList, setTableList] = useState([]);
  const [filterType, setFilterType] = useState("all"); // "all", "credit", "debit"
  const setTransList = SetCustomerTransListAtom();
  const resetTransList = ResetCustomerTransListAtom();
  const transList = GetCustomerTransListAtom();

  useEffect(() => {
    getDataFromServer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer_id, transList.transation_history?.length]);

  useEffect(() => {
    // Apply filter whenever filterType changes
    applyFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterType, transList.transation_history]);

  const getDataFromServer = () => {
    let isMounted = true;
    customerService.getCustomerTransactions(customer_id).then((res) => {
      if (isMounted && res.data?.transation_history?.length) {
        setTransList(res.data);
        // Filter will be applied by the useEffect
      } else if (isMounted) {
        resetTransList();
        setTableList([]);
      }
    });
    return () => {
      isMounted = false;
    };
  };

  const applyFilter = () => {
    if (!transList.transation_history?.length) {
      setTableList([]);
      return;
    }

    let filteredList = transList.transation_history;
     
    if (filterType === "credit") {
      filteredList = transList.transation_history.filter(
        (item) => item.Transaction_Group === "Credit"
      );
    } else if (filterType === "debit") {
      filteredList = transList.transation_history.filter(
        (item) => item.Transaction_Group === "Debit"
      );
    }

    setTableList(filteredList);
  };

  const onTypeSelect = (selection) => {
    if (selection?.Transaction_Type_Id === 0) {
      return setTableList(transList.transation_history);
    }
    let newList = transList.transation_history.filter(
      (item) => item.transaction_type_id === selection?.Transaction_Type_Id
    );
    setTableList(newList);
  };

  console.info("tableList ", tableList);

  return (
    <>
      <div className="ml-1 @container">
        <div className="md:flex md:flex-row md:items-center md:justify-between">
          <div className="mt-1 text-gray-600 text-xl font-bold">
            transaction History
          </div>
          <div className="mr-1 mt-3 md:mt-0">
            <CustomerHistorySelect
              optionList={transList.transation_type}
              onTypeSelect={onTypeSelect}
            />
          </div>
        </div>

        {/* Filter Toggles */}
        <div className="mt-4 flex gap-2 flex-wrap">
          <button
            onClick={() => setFilterType("all")}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              filterType === "all"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilterType("credit")}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              filterType === "credit"
                ? "bg-green-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Credit
          </button>
          <button
            onClick={() => setFilterType("debit")}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              filterType === "debit"
                ? "bg-red-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Debit
          </button>
        </div>

        <section className="mt-5">
          <GeneralCustomTable
            tableHeadList={columns}
            tableDataList={tableList}
            allowCheckBox={false}
            rowKey={(record) => record.Ref_No}
            handleRowClick={() => console.log('click')}
          />
        </section>
      </div>
    </>
  );
}